import { useState } from 'react'

export const OB = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalImage, setModalImage] = useState()

    const handleOpenModal = (imageNumber) => {
        setModalImage(imageNumber)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    return (
        <>
            <div className='max-w-[1200px] mx-auto'>
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-ob-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Lorsqu'un personnage ou un objet tombe hors de la carte, on dit qu'il devient{' '}
                        <span className='text-pborange'>Hors Zone</span>. Les personnages qui en sont victimes{' '}
                        <span className='text-pborange'>ubissent des dégâts et perdent des PV</span>.
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <div className='mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal(1)
                                }}
                                className='ss-thumb max-w-full'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-1-s.webp`}
                            />{' '}
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                La quantité de dégâts subis dépend de la carte. En outre, les personnages victimes d'un
                                Hors Zone sont replacés sur la carte à l'emplacement le plus proche de là où ils ont
                                fait un Hors Zone.
                            </p>
                        </div>{' '}
                        <div className='mx-auto mt-8'>
                            <img
                                onClick={() => {
                                    handleOpenModal(2)
                                }}
                                className='ss-thumb max-w-full'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-2-s.webp`}
                            />{' '}
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                Les différences de niveaux n'influent pas sur les dégâts des Hors Zone. C'est donc une
                                technique très utile lorsque vous affrontez des ennemis plus forts que vous !
                            </p>
                        </div>{' '}
                    </div>{' '}
                    <p className='mt-8'>
                        La commande Lancer vous permet d'envoyer des objets hors de la carte. Il est également possible
                        de les lancer sur de la glace, auquel cas ils risquent de glisser jusqu'à sortir de la carte, ou
                        de les lancer à partir d'un lieu situé en hauteur, auquel cas ils risquent de sortir des
                        limites. Ainsi, diverses actions et les caractéristiques du terrain peuvent contribuer à un Hors
                        Zone.
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal(3)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-3-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Si vous tombez hors de la carte suite à un déplacement ou à cause de vos propres actions, ce
                            ne sera pas considéré comme un Hors Zone, et vous ne subirez aucun dégât.
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        En revanche, si un objet passe Hors Zone, <span className='text-pborange'>il disparaît</span>.
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal(4)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-4-s.webp`}
                        />{' '}
                    </div>{' '}
                    <p className='mt-8'>
                        Par exemple, si vous voulez un certain objet, mais qu'un ennemi le lance Hors Zone, il
                        disparaîtra.
                    </p>{' '}
                    <p>
                        Parfois, il peut se révéler nécessaire d'effectuer un combinage avec un objet que vous voulez
                        avant d'engager le combat avec l'ennemi. Si un fantôme est combiné avec l'objet, le message «
                        Rapporté ! » apparaîtra, et vous recevrez l'objet en question.
                    </p>{' '}
                </div>{' '}
                <div
                    onClick={handleCloseModal}
                    className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='w-full md:w-[80%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30'
                    >
                        <div className='flex flex-row items-center mx-auto md:gap-4'>
                            <div>
                                {modalImage > 1 && modalImage < 5 ? (
                                    <button onClick={() => setModalImage(modalImage - 1)} className=''>
                                        <img
                                            className='w-full min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                            alt={`right`}
                                        />{' '}
                                    </button>
                                ) : (
                                    <button>
                                        <img
                                            className='w-full brightness-50 min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                            alt={`left`}
                                        />
                                    </button>
                                )}
                            </div>

                            <div className='relative'>
                                <button
                                    onClick={handleCloseModal}
                                    className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                                >
                                    <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />{' '}
                                </button>
                                <img
                                    className='white-drop-shadow max-w-[1920px] mx-auto w-full'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-${modalImage}.webp`}
                                    alt={`screen shot of game system`}
                                />{' '}
                            </div>

                            <div>
                                {modalImage === 4 ? (
                                    <button>
                                        <img
                                            className='w-full brightness-50 min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                            alt='right'
                                        />
                                    </button>
                                ) : (
                                    <button onClick={() => setModalImage(modalImage + 1)} className=' '>
                                        <img
                                            className='w-full min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                            alt='right'
                                        />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>{' '}
            </div>
        </>
    )
}
